<template>
  <!--  ==============================  MODAL_SECTION START ============================== -->
  <b-modal
    id="modal-money-report"
    :title="editMode == true ?  $t('edition') : $t('daily__data')"
    cancel-variant="outline-secondary"
    :ok-title="editMode == true ? $t('general.edit') : $t('general.add')"
    ok-variant="success"
    :cancel-title="$t('general.close')"
    centered
    no-close-on-backdrop
    @cancel="onCancel"
    @close="onCancel"
    @show="showModal"
    @ok="onSubmitMoney"
  >
    <b-form>
      <validation-observer ref="moneyValidations">
        <b-form-group :label="$t('courses.type')">
          <validation-provider
            #default="{ errors }"
            :name="$t('courses.type')"
            rules="required"
          >
            <v-select
              v-model="report.type"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :reduce="(p) => p.id"
              label="type"
              :get-option-label="(opt) => opt.title[$i18n.locale]"
              :options="type_money_options"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-form-group :label="$t('namee')">
          <validation-provider
            #default="{ errors }"
            :name="$t('namee')"
            rules="required"
          >
            <b-form-input v-model="report.name" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </validation-observer>
    </b-form>
  </b-modal>
  <!--  ==============================  MODAL_SECTION END ============================== -->
</template>

<script>
import { BModal, VBModal, BForm, BFormInput, BFormGroup } from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions } from "vuex";

export default {
  name: "AddEditModal",
  components: {
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  props: {
    editMoney: {
      type: Object,
      default: () => ({}),
      required: false,
    },
  },
  data() {
    return {




      // ===============  PRIMARY_DATA_SECTION START ===============
      option: [],
      report: {
        type: null,
        name: "",
      },
      editMode: false,
      // ===============  PRIMARY_DATA_SECTION END ===============




    };
  },
  methods: {
    ...mapActions("moneyReport", [
      "CREATE_MONEY_REPORT",
      "UPDATE_MONEY_REPORT",
    ]),





    // ===============  ON_SHOW_SECTION START ===============
    showModal() {
      this.editMode = this.$route.params.editMode
      this.report = {
        type: "",
        name: "",
      };
      if (!this.editMoney) {
        return;
      }

      if (typeof this.editMoney === "object" && this.editMoney !== null) {
        this.report.type = this.editMoney.type;
        this.report.name = this.editMoney.name;
      }
    },
    // ===============  ON_SHOW_SECTION END ===============



    onCancel(){
      this.$route.params.editMode = false
    },
    onClose(){
      this.$route.params.editMode = false
    },



    // ===============  ON_SUBMIT_SECTION START ===============
    onSubmitMoney(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$refs.moneyValidations.validate().then((success) => {
        if (!success) {
          this.$_errToast({message: this.$t('all_fields_are_required')});
          return;
        }

        try {
          if (this.editMoney.id) {
            this.UPDATE_MONEY_REPORT({
              id: this.editMoney.id,
              data: this.report,
            }).then(async () => {
              await this.$parent.refresh()
            });
          } else {
            this.CREATE_MONEY_REPORT(this.report).then(async () => {
              await this.$parent.refresh()
            });
          }
          this.$nextTick(() => {
            this.$route.params.editMode = false
            this.$bvModal.hide("modal-money-report");
          });

          this.report = {
            name: "",
            type: null,
          };

          this.$_okToast();
        } catch (err) {
          this.$_errToast(err);
        }
      });
    },
    // ===============  ON_SUBMIT_SECTION END ===============





  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
